import { ModalHeader as NextUIModalHeader, ModalHeaderProps as NextUIModalHeaderProps } from "@heroui/react";
export interface ModalHeaderProps extends NextUIModalHeaderProps {}
export const ModalHeader = ({children, ...props}:ModalHeaderProps) => {
  return (
    <NextUIModalHeader {...props}>
      {children}
    </NextUIModalHeader>
  )
}